import { FC, ReactNode } from 'react';

import { H2, PageTile, PageTileBody } from '@portal/common/components';
import { styled } from '@portal/common/theme';

const StyledPageTile = styled(PageTile)(({ theme }) => ({
    background: theme.color.warning,
    color: theme.color.white,
    padding: `20px 30px 30px`,
    '& a': {
        color: theme.color.white,
        fontWeight: 'bold',
        textDecoration: 'underline',
    },
}));

const StyledBody = styled(PageTileBody)(({ theme }) => ({
    margin: '20px 0 0',
    span: {
        fontSize: 14,
    },
}));

interface LicenseMessageTileProps {
    title: string;
    children: ReactNode;
}

const LicenseMessageTile: FC<LicenseMessageTileProps> = ({ title, children }) => {
    return (
        <StyledPageTile>
            <H2>{title}</H2>
            <StyledBody>{children}</StyledBody>
        </StyledPageTile>
    );
};

export default LicenseMessageTile;
